import React from 'react';
import './VideoLoop.scss';
import videoLoopD from '../../assets/videoLoopD.mp4';

function VideoLoop() {
  return (
    <section className="videoLoop">
      <div className="videoLoop__videoContainer">
        <video autoPlay muted loop playsInline className="video">
          <source src={videoLoopD} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="videoLoop__copyContainer">
        <p className="videoLoop__copyContainer-copy">
          Where are people moving to find more spacious homes?{' '}
          <a
            className="hyperLink mapLink"
            href="https://sponsorcontent.cnn.com/interactive/nar/map/"
            target="_blank"
            rel="sponsored"
          >
            The State of Housing in America
          </a>
          , a new map from the National Association of REALTORS®, lets you explore 173 metro areas
          to see where populations and projected housing demand are rising fastest.
        </p>
        <a
          className="videoLoop-control mapLink"
          target="_blank"
          rel="sponsored"
          href="https://sponsorcontent.cnn.com/interactive/nar/map/"
        >
          <div className="buttons">Explore Map</div>
        </a>
      </div>
    </section>
  );
}

export default VideoLoop;
